"use client";

import { useSession } from "next-auth/react";

function getHeaderDashboardLabel(role?: string) {
  switch (role) {
    case "PATIENT":
      return "Moje Sesije";
    case "THERAPIST":
      return "Moje Terapije";
    case "SUPER_ADMIN":
      return "Admin Panel";
    default:
      return "Dashboard";
  }
}

export function useHeaderAccount() {
  const session = useSession();

  return {
    isAuthenticated: session.status === "authenticated",
    dashboardLabel: getHeaderDashboardLabel(session.data?.user.role),
  };
}
